/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum MissionType {
    ACCOUNTS = 'Accounts',
    PAYMENTS = 'Payments',
    VRPCONSENT = 'VrpConsent',
    BULK_PAYMENTS = 'BulkPayments',
}